module.exports = __webpack_public_path__ + "img/gsndc2762_1.6965cdf7.svg";